import TemplatesBuilder from "../../src/TemplatesBuilder"
import {
  datasetFromJsonld,
  resourceToName,
} from "../../src/utilities/Utilities"
import _ from "lodash"

const resourceFilenames = {
  "c7db5404-7d7d-40ac-b38e-c821d2c3ae3f": "test.json",
  "c7db5404-7d7d-40ac-b38e-c821d2c3ae3f-invalid": "invalid_rt.json",
  "c7db5404-7d7d-40ac-b38e-c821d2c3ae3f-invalid-template":
    "invalid_instance.json",
  "a4181509-8046-47c8-9327-6e576c517d70": "test2.json",
  "9c5bd9f5-1804-45bd-99ed-b6e3774c896e": "instance.json",
  "a5c5f4c0-e7cd-4ca5-a20f-2a37fe1080d5": "instance_with_refs.json",
  "f6ee6410-5206-492b-8e48-3b6333010c33": "work_with_refs.json",
  "b6c5f4c0-e7cd-4ca5-a20f-2a37fe1080d6": "test-inputs.json",
  "c7c5f4c0-e7cd-4ca5-a20f-2a37fe1080d7": "test-multiple_property_uris.json",
  // Blue Core-shaped URI: http://localhost:3000/works/<uuid>
  "d4e1b2a3-5c6f-4a7b-8c9d-0e1f2a3b4c5d": "blue_core_work.json",
  // Resources whose literals carry no language tag, as when ingested from LC.
  "e1f2a3b4-5c6d-4e7f-8a9b-0c1d2e3f4a5b": "untagged_inputs.json",
  "f2a3b4c5-6d7e-4f8a-9b0c-1d2e3f4a5b6c": "untagged_suppress_language.json",
  "a3b4c5d6-7e8f-4a9b-8c0d-2e3f4a5b6c7d": "untagged_typed_literal.json",
}

const templateFilenames = {
  "test:resource:DiscogsLookup": "DiscogsLookup.json",
  "resourceTemplate:bf2:Note": "Note.json",
  "resourceTemplate:bf2:Note:Immutable": "Immutable.json",
  "test:resource:SinopiaLookup": "SinopiaLookup.json",
  "resourceTemplate:bf2:Title": "Title.json",
  "resourceTemplate:bf2:Title:Note": "TitleNote.json",
  "resourceTemplate:bf2:Title:Note:OptionalClass":
    "TitleNoteOptionalClass.json",
  "test:resource:WikidataLookup": "WikidataLookup.json",
  "resourceTemplate:bf2:WorkTitle": "WorkTitle.json",
  "rt:repeated:propertyURI:propertyLabel": "propertyURIRepeated.json",
  "test:RT:bf2:notFoundValueTemplateRefs": "notFoundValueTemplateRefs.json",
  "ld4p:RT:bf2:Form": "ld4p_RT_bf2_Form.json",
  "ld4p:RT:bf2:RareMat:RBMS": "ld4p_RT_bf2_RareMat_RBMS.json",
  "ld4p:RT:bf2:Title:AbbrTitle": "ld4p_RT_bf2_Title_AbbrTitle.json",
  "test:RT:bf2:RareMat:Instance": "nonUniqueValueTemplateRefs.json",
  "resourceTemplate:testing:uber1": "uber_template1.json",
  "resourceTemplate:testing:uber2": "uber_template2.json",
  "resourceTemplate:testing:uber3": "uber_template3.json",
  "resourceTemplate:testing:uber4": "uber_template4.json",
  "resourceTemplate:testing:uber5": "uber_template5.json",
  "resourceTemplate:bf2:Instance": "Instance.json",
  "resourceTemplate:bf2:Work": "Work.json",
  "resourceTemplate:testing:literal": "testing_literal.json",
  "resourceTemplate:testing:uri": "testing_uri.json",
  "resourceTemplate:testing:suppressedUri": "testing_suppressed_uri.json",
  "resourceTemplate:testing:suppressedUri2": "testing_suppressed_uri2.json",
  "resourceTemplate:testing:inputs": "testing_inputs.json",
  "resourceTemplate:testing:ordered": "testing_ordered.json",
  "resourceTemplate:testing:suppressible": "testing_suppressible.json",
  "resourceTemplate:testing:suppressibleAmbiguous":
    "testing_suppressible_ambiguous.json",
  "resourceTemplate:testing:richUri": "testing_rich_uri.json",
  "resourceTemplate:testing:richUri2": "testing_rich_uri2.json",
  "resourceTemplate:testing:ambiguousClassNonSuppressible":
    "testing_ambiguous_class_non_suppressible.json",
  "resourceTemplate:testing:typedRichUri": "testing_typed_rich_uri.json",
  "resourceTemplate:testing:ambiguousClassTypedSibling":
    "testing_ambiguous_class_typed_sibling.json",
  "resourceTemplate:testing:ambiguousClassMultipleNonSuppressible":
    "testing_ambiguous_class_multiple_non_suppressible.json",
  "resourceTemplate:testing:multiplePropertyUris":
    "testing_multiple_property_uris.json",
  "resourceTemplate:testing:suppressLanguage": "testing_suppress_language.json",
  "resourceTemplate:testing:literalValidation":
    "testing_literalValidation.json",
  "resourceTemplate:testing:dupeProperties": "testing_dupe_properties.json",
  "resourceTemplate:testing:multipleClassLiteral":
    "testing_multiple_class_literal.json",
  "resourceTemplate:testing:multipleClassInputs":
    "testing_multiple_class_inputs.json",
  "resourceTemplate:testing:lookup": "testing_lookups.json",
  "resourceTemplate:testing:mergeDefaultsHost":
    "testing_merge_defaults_host.json",
  "resourceTemplate:testing:mergeDefaultsMatch":
    "testing_merge_defaults_match.json",
  "resourceTemplate:testing:mergeDefaultsSibling":
    "testing_merge_defaults_sibling.json",
  "resourceTemplate:testing:requiredSingleDefaultHost":
    "testing_required_single_default_host.json",
  "resourceTemplate:testing:namedNodeMultiProp":
    "testing_named_node_multi_prop.json",
  "resourceTemplate:testing:sharedOptionalClass":
    "testing_shared_optional_class.json",
  "resourceTemplate:testing:cycleA": "testing_cycle_a.json",
  "resourceTemplate:testing:cycleB": "testing_cycle_b.json",
  "resourceTemplate:testing:selfCycle": "testing_self_cycle.json",
  "resourceTemplate:testing:namedNodeMultiPropHost":
    "testing_named_node_multi_prop_host.json",
  // The bare id resolves to whatever the profile says today, which is v2.
  // Its version URIs are registered in profileTemplateFilenames below.
  "bluecore:bf2:Title:VersionedTitle": "versioned_title_v2.json",
}

// Template fixtures addressed the way Blue Core addresses profiles, for
// version-pinning coverage. resourceToName() cannot reach these: it returns the
// last path segment, so ".../profiles/{uuid}/version/2" would name itself "2".
// Keyed by everything after "/profiles/". The unversioned key resolves to the
// latest version, which is what an unversioned profile URI means.
const profileTemplateFilenames = {
  "3db30d3a-7a3e-4762-a28c-1a0efc244345": "versioned_title_v2.json",
  "3db30d3a-7a3e-4762-a28c-1a0efc244345/version/1": "versioned_title_v1.json",
  "3db30d3a-7a3e-4762-a28c-1a0efc244345/version/2": "versioned_title_v2.json",
  // A mutual cycle expressed entirely in version URIs.
  "11111111-1111-4111-8111-111111111111/version/1": "versioned_cycle_a.json",
  "22222222-2222-4222-8222-222222222222/version/1": "versioned_cycle_b.json",
  // Typed as a resource template but carrying no hasResourceId.
  "44444444-4444-4444-8444-444444444444": "untyped_id_template.json",
  // Served by an API that reports version_uri; see below.
  "55555555-5555-4555-8555-555555555555": "versioned_title_v2.json",
}

// The version_id of the version_uri an API response carries for a profile
// (blue-core-lod/bluecore_api#338). Profiles not listed here are served as by
// an API that predates the field.
const profileVersionIds = {
  "55555555-5555-4555-8555-555555555555": 48213,
}

const profileFixtureKey = (uri) => {
  if (!_.isString(uri)) return undefined
  const index = uri.indexOf("/profiles/")
  if (index === -1) return undefined
  return uri.slice(index + "/profiles/".length)
}

export const hasFixtureResource = (uri) => {
  return (
    !!profileTemplateFilenames[profileFixtureKey(uri)] ||
    !!resourceFilenames[resourceToName(uri)] ||
    !!templateFilenames[resourceToName(uri)] ||
    ["http://error", "http://localhost:3000/resource/ld4p:RT:bf2:xxx"].includes(
      uri,
    )
  )
}

export const getFixtureResource = (uri) => {
  // A special URI for testing.
  if (uri === "http://error") throw new Error("Ooops")
  if (uri === "http://localhost:3000/resource/ld4p:RT:bf2:xxx")
    throw new Error("Error retrieving resource: Not Found")
  const id = resourceToName(uri)
  const profileFilename = profileTemplateFilenames[profileFixtureKey(uri)]
  // For some reason, require must have __xxx__ and cannot be provided in variable.
  let resource
  if (profileFilename) {
    /* eslint security/detect-non-literal-require: 'off' */
    resource = require(`../__template_fixtures__/${profileFilename}`)
  } else if (resourceFilenames[id]) {
    resource = require(`../__resource_fixtures__/${resourceFilenames[id]}`)
  } else {
    resource = require(`../__template_fixtures__/${templateFilenames[id]}`)
  }

  const versionId = profileVersionIds[profileFixtureKey(uri)]

  return {
    id,
    uri,
    data: resource,
    ...(versionId && { version_uri: `${uri}/version/${versionId}` }),
    group: "stanford",
    editGroups: ["cornell"],
    timestamp: "2020-08-20T11:34:40.887Z",
    bfAdminMetadataRefs: [],
    bfItemRefs: [],
    bfInstanceRefs: [],
    bfWorkRefs: [],
    sinopiaLocalAdminMetadataForRefs: [],
  }
}

// Cache of search results
const fixtureTemplateSearchResults = {}

// These are used as fake template search results
export const getFixtureTemplateSearchResults = () => {
  if (!_.isEmpty(fixtureTemplateSearchResults))
    return Object.values(fixtureTemplateSearchResults)

  return Promise.all(
    Object.keys(templateFilenames).map((id) => {
      const jsonld = require(
        `../__template_fixtures__/${templateFilenames[id]}`,
      )
      return datasetFromJsonld(jsonld).then((dataset) => {
        const uri = `http://localhost:3000/resource/${id}`
        const template = new TemplatesBuilder(dataset, uri).build()
        const result = {
          id: template.id,
          author: template.author,
          date: template.date,
          remark: template.remark,
          resourceLabel: template.label,
          resourceURI: template.class,
          group: "stanford",
          editGroups: ["cornell"],
          uri,
        }
        fixtureTemplateSearchResults[result.id] = result
        return result
      })
    }),
  )
}

// These are used as fake resource search results
export const resourceSearchResults = (
  uri,
  type = "http://id.loc.gov/ontologies/bibframe/Fixture",
) => {
  return [
    {
      totalHits: 1,
      results: [
        {
          uri,
          label: uri,
          created: "2020-07-15T20:48:29.274Z",
          modified: "2020-07-15T21:04:46.012Z",
          type: [type],
          group: "stanford",
          editGroups: ["cornell"],
        },
      ],
    },
    {
      types: [
        {
          key: type,
          doc_count: 1,
        },
      ],
      groups: [
        {
          key: "stanford",
          doc_count: 1,
        },
      ],
    },
  ]
}

export const getFixtureResourceVersions = () => {
  return [
    {
      id: 1,
      timestamp: "2021-10-22T13:26:35.238Z",
      user: "jlittman",
      group: "other",
      editGroups: [],
      templateId: "resourceTemplate:testing:uber1",
    },
    {
      id: 2,
      timestamp: "2021-10-22T22:25:58.305Z",
      user: "jlittman",
      group: "other",
      editGroups: [],
      templateId: "resourceTemplate:testing:uber1",
    },
    {
      id: 3,
      timestamp: "2021-10-22T22:30:19.732Z",
      user: "jlittman",
      group: "other",
      editGroups: [],
      templateId: "resourceTemplate:testing:uber1",
    },
  ]
}

export const getFixtureResourceRelationships = () => {
  return {
    bfAdminMetadataInferredRefs: [],
    bfItemInferredRefs: [],
    bfInstanceInferredRefs: [],
    bfWorkInferredRefs: [],
  }
}
